import { bindDialog } from '@/utils/dialog';

let offerDialog = null;
let offerTrigger = null;

function getOfferDialog() {
    if (offerDialog) {
        return offerDialog;
    }

    offerDialog = document.createElement('dialog');
    offerDialog.className = 'dialog custom-modal package-offer-dialog';
    offerDialog.setAttribute('aria-labelledby', 'package-offer-dialog-title');
    offerDialog.innerHTML = `
        <div class="custom-modal__header">
            <h2 class="custom-modal__title" id="package-offer-dialog-title"></h2>
            <button type="button" class="dialog__close" data-dialog-close>
                Close <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>
        </div>
        <div class="custom-modal__content"></div>
    `;
    bindDialog(offerDialog, () => {
        offerTrigger?.focus();
        offerTrigger = null;
    });
    document.body.appendChild(offerDialog);

    return offerDialog;
}

document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-offer-template]') : null;
    const template = trigger ? document.getElementById(trigger.dataset.offerTemplate) : null;
    if (!template) {
        return;
    }

    const dialog = getOfferDialog();
    dialog.querySelector('.custom-modal__title').textContent = trigger.dataset.offerTitle || 'Special offer';
    dialog.querySelector('.custom-modal__content').replaceChildren(template.content.cloneNode(true));
    offerTrigger = trigger;
    dialog.showModal();
});
